import { Paper, Center, Loader, Text } from "@mantine/core";

import { ListWorkOrderDto } from "../../models/workorder.models";
import { useGetWorkOrdersByTeamIdQuery } from "../../api/workorder.api";
import { WorkOrderListItem } from "../WorkOrders/WorkOrderListItem";

interface TeamWorkOrderListProps {
	teamId: string;
	onSelect?: (workOrder: ListWorkOrderDto) => void;
	selectedWorkOrderId?: string | null;
}

export const TeamWorkOrderList = ({ teamId, onSelect, selectedWorkOrderId }: TeamWorkOrderListProps) => {
	const { data: workOrders, isLoading } = useGetWorkOrdersByTeamIdQuery(teamId);

	// const filteredWorkOrders = workOrders?.filter(workOrder => workOrder.UserId === userId) || [];

	const sortedWorkOrders = workOrders?.sort((a, b) => new Date(b.Created).getTime() - new Date(a.Created).getTime()) ?? [];

	if (isLoading) return <>
		<Center>
			<Loader size="sm" mt="lg" />
		</Center>
	</>;

	if (!workOrders?.length) return <Text c="dimmed">No work orders for this team.</Text>;

	return (
		<Paper p={0} radius="md" style={{ overflow: 'hidden' }}>
			{sortedWorkOrders.map(workOrder => (
				<WorkOrderListItem
					key={workOrder.WorkOrderId}
					workOrder={workOrder}
					selected={selectedWorkOrderId === workOrder.WorkOrderId}
					onSelect={onSelect ? onSelect : () => { }}
					showCategories={true}
				/>
			))}
		</Paper>
	);
};
